import { render, staticRenderFns } from "./UnsubscribeDialog.vue?vue&type=template&id=45bea377&scoped=true&"
import script from "./UnsubscribeDialog.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeDialog.vue?vue&type=style&index=0&id=45bea377&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bea377",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
